// src/components/imagery/EntitledMaskError.jsx
//
// The map's notice when GET /imagery/entitled fails: the map stays dimmed
// everywhere (useEntitledFootprints fails closed) and says so, with a Retry.
export default function EntitledMaskError({ onRetry, className = "" }) {
  return (
    <div role="alert" data-testid="fp-entitled-error"
      className={`pointer-events-auto flex items-center gap-2 rounded bg-black/70 px-2.5 py-1.5 text-[12px] text-white ${className}`}>
      <span>Couldn't load your imagery coverage. The map stays dimmed until it loads.</span>
      <button type="button" className="op-btn op-btn--sm" data-testid="fp-entitled-retry" onClick={onRetry}>Retry</button>
    </div>
  );
}
